<template>
  <div
    id="users"
    class="row"
  >
    <div class="col-12">
      <vuetify-table
        :headers="headers"
        :api-u-r-l="apiURL"
        :title="title"
        :back="true"
        back-u-r-l="enterprises"
        permisosNuevoRegistro="crear_asociado_empresa"
        permisosEditar="editar_asociado_empresa"
        permisosEliminar="eliminar_asociado_empresa"
      />
    </div>
  </div>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  components: {
    VuetifyTable,
  },
  props: {
    id: { default: '' },
    action: { default: '' },
    message: { default: '' },
  },
  data: () => ({
      headers: [
        {
          text: 'Asociado',
          value: 'ruc_associate',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Razón Social',
          value: 'name_associate',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Estado',
          value: 'active',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
    name: '',
  }),
  computed: {
    apiURL() {
      return `/api/enterprises/${this.id}/partners`;
    },
    title() {
      return `Asociados de <b>${this.name}</b>`;
    },
  },
  mounted() {
    if (!this.can('cambiar_estado_asociado_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
    if (!this.can('editar_asociado_empresa') && !this.can('eliminar_asociado_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
    }
    window.axios.get(`/api/enterprises/${this.id}`)
    .then((result) => {
      this.name = `${result.data.name} - ${result.data.ruc}`;
    });
  },
};
</script>
